var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEquals = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 64 64"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M58 24.12H6c-1.1 0-2-1.143-2-2.541s.9-2.542 2-2.542h52c1.1 0 2 1.144 2 2.542s-.9 2.541-2 2.541m0 20.843H6c-1.1 0-2-1.144-2-2.542s.9-2.541 2-2.541h52c1.1 0 2 1.143 2 2.541s-.9 2.542-2 2.542"
})));
export default SvgEquals;